module.exports = __webpack_public_path__ + "img/picture.91f8edf4.svg";